import React, { Component } from 'react';
import styles from './selectFeaturedCharity.less';
import {
  Row,
  Col,
  Icon,
  Alert,
  Link,
  BodyText,
  HeadingText,
  CaptionText,
} from '@paypalcorp/pp-react';
import * as analytics from '../../lib/analytics';
import get from 'lodash/get';
import uniq from 'lodash/uniq';
import DonateBox from '../../components/donateBox';
import DonationTerms from '../donation-terms';
import { getType } from '../../lib/charity';
import Spinner from '../spinner/Spinner';
import SetPreferredHeart from '../SetPreferredHeart/SetPreferredHeart';
import utils from '../../lib/utils';

export default class SelectedFeaturedCharity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
    };
  }

  handleKeyPressOnNavBack(e) {
    if (e.key === 'Enter') {
      this.props.handleBackNavigation();
    }
  }

  handleKeyPress(e, callback) {
    if (e.key === 'Enter') {
      return callback();
    }
  }

  charityLogo(charity, index) {
    return (
      <div>
        <div
          className={styles.charityImage}
          id={`charity-avatar-${index}`}
          style={{
            background: `url(${charity.logo_url}) no-repeat center, center`,
            backgroundSize: 'contain',
          }}
          data-nemo='npo-avatar'
        />
      </div>
    );
  }

  charityName(charity) {
    let charityName = charity.name || '';
    let charityNameLength = charityName.length;

    // need to trim the name only if there is a need and display issue.
    let charityNameStripped;
    if (charityNameLength > 40) {
      charityNameStripped = charityName.substr(0, 40).concat('...');
    }

    return (
      <div className={'charityName'}>
        <BodyText as='p' size='md' className={'charitytext'} strong>
          {charity.name}
        </BodyText>
      </div>
    );
  }

  charityCategories(charity) {
    let categories = [];
    if (Array.isArray(charity.cause_area)) {
      categories =
        uniq(
          charity.cause_area.map((causeArea) =>
            this.props.i18n(`label.category-${causeArea.id}`)
          )
        ) || [];
    }

    const charityCategories = categories.map((category, categoryIndex) => {
      if (categoryIndex === categories.length - 1) {
        return (
          <span>
            <CaptionText
              key={categoryIndex}
              size='md'
              className={styles.categoryDisplay}
            >
              {category}
            </CaptionText>
          </span>
        );
      } else {
        return (
          <span key={categoryIndex}>
            <CaptionText size='md' className={styles.categoryDisplay}>
              {category}
            </CaptionText>
            {', '}
          </span>
        );
      }
    });
    return charityCategories;
  }

  setPreferredFetch = (charity) => {
    this.setState(
      {
        isLoading: true,
        heartError: false,
      },
      () => {
        fetch('/fundraiser/setPreferredCharity', {
          method: 'POST',
          body: JSON.stringify({
            _csrf: this.props.csrf,
            npid: charity.nonprofit_id,
            setPreferred:
              this.props.preferredCharityNpid !== charity.nonprofit_id,
          }),
          headers: {
            'Content-Type': 'application/json',
          },
        })
          .then((response) => {
            if (response.status >= 400) {
              this.setState({
                isLoading: false,
                heartError: true,
              });
            } else {
              return response.json();
            }
          })
          .then((data) => {
            const { setPreferredSuccess } = data;
            if (setPreferredSuccess) {
              this.setState({
                isLoading: false,
              });
              this.props.handleSetFavCharityChange();
              analytics.trackLinkWithData(
                'featuredCharityHeartClicked',
                this.props.fptiInfo.pgrp,
                this.props.fptiInfo.page,
                {
                  charityFavorited:
                    this.props.preferredCharityNpid === charity.nonprofit_id,
                  crid: charity.nonprofit_id,
                },
                'link'
              );
            } else {
              this.setState({
                isLoading: false,
                heartError: true,
              });
            }
          });
      }
    );
  };

  renderSetPreferred(charity, isLoggedIn) {
    const charityType = get(charity, 'charity_type', 'PPGF').toUpperCase();
    const isUnEnrolled =
      charityType === 'EXTERNAL' || charityType === 'GUIDESTAR';
    const isMerchant = this.props.userType === 'BUSINESS';
    if (
      this.props.isCountrySetPreferredSupported &&
      !isUnEnrolled &&
      !isMerchant
    ) {
      return (
        <div>
          {this.state.isLoading ? (
            <div className={styles.spinner}>
              <Spinner size='sm' />
            </div>
          ) : (
            <Link
              href={
                !isLoggedIn
                  ? utils.getUnifiedLoginURL(this.props.unifiedLoginURL, [
                      {
                        key: 'setPreferredNpid',
                        value: charity.nonprofit_id,
                      },
                    ])
                  : undefined
              }
              data-nemo={!isLoggedIn ? 'npo-heart-link' : undefined}
              leftIcon={
                <SetPreferredHeart
                  selected={
                    this.props.preferredCharityNpid === charity.nonprofit_id
                  }
                  hubFlow={true}
                />
              }
              onClick={() => {
                if (isLoggedIn) {
                  this.setPreferredFetch(charity);
                }
              }}
              className={styles['link-with-icon']}
            >
              <CaptionText
                as='p'
                size='md'
                className={styles['link-with-icon-text']}
                strong
              >
                {this.props.preferredCharityNpid === charity.nonprofit_id
                  ? this.props.i18n('label.preferred-charity')
                  : this.props.i18n('label.set-preferred')}
              </CaptionText>
            </Link>
          )}
          {this.state.heartError ? (
            <div className={styles['alert-margin']}>
              <Alert type='attention'>
                {this.props.i18n('label.setPref-errorAlert')}
              </Alert>
            </div>
          ) : null}
        </div>
      );
    }
  }

  renderCharityInfo(charity, selectedIndex) {
    const npoUrl = `${this.props.npoBaseUrl}${charity.nonprofit_id}`;
    const isLoggedIn = !(
      this.props.authState === 'ANONYMOUS' ||
      this.props.authState === 'IDENTIFIED'
    );
    const setPreferred = this.renderSetPreferred(charity, isLoggedIn);
    const charityInfo = (
      <div className={styles.charityInfoDiv}>
        <div className={styles.charityImageContainer}>
          {this.charityLogo(charity, selectedIndex)}
        </div>
        <div style={{ marginBottom: '15px' }}>
          {this.charityName(charity)}
          {this.charityCategories(charity)}
        </div>
        <Link
          leftIcon={<Icon name='info' size='md' />}
          onClick={() => {
            this.props.handleInfoClick();
            window.open(npoUrl);
          }}
          className={styles['link-with-icon']}
        >
          <CaptionText
            as='p'
            size='md'
            className={styles['link-with-icon-text']}
            strong
          >
            {this.props.i18n('label.infoIcon')}
          </CaptionText>
        </Link>
        {setPreferred}
      </div>
    );
    return charityInfo;
  }

  renderBackLink() {
    return (
      <div
        className={styles.backNav}
        tabIndex='0'
        role='link'
        onKeyDown={this.handleKeyPressOnNavBack.bind(this)}
      >
        <Icon className={styles.backIconColor} name='arrow-left' size='sm' />
        <BodyText
          as='p'
          regular
          size='md'
          className={styles.backText}
          onClick={() => this.props.handleBackNavigation()}
        >
          {this.props.i18n('label.back-link')}
        </BodyText>
      </div>
    );
  }

  renderDonationBox(charity) {
    let npid = charity.nonprofit_id;
    // TODO This formUrl is very Important piece of code. Need to think how to make it more secure
    const formUrl = this.props.coBrand + 'charity/' + npid + '/xo/create';
    return (
      <DonateBox
        charity={charity}
        id={charity.nonprofit_id}
        amounts={this.props.amounts}
        csrf={this.props.csrf}
        coBrand={this.props.coBrand}
        formUrl={formUrl}
        charityContent={charity.charityContent}
        enable={this.props.enable}
        fptiInfo={this.props.fptiInfo}
        i18n={this.props.i18n}
        cdnHost={this.props.cdnHost}
      />
    );
  }

  renderDonationTerms(charity) {
    const type = getType(charity);
    const charityContent = charity.charityContent;
    return (
      <div className={styles.donationTermsDiv}>
        <DonationTerms
          type={type}
          i18n={this.props.i18n}
          donationTerms={charityContent.donationTerms}
        />
      </div>
    );
  }

  render() {
    const charity = this.props.charity;
    const selectedIndex = this.props.selectedIndex;

    return (
      <div className={styles.selectedCharityPanel}>
        <Row>
          {this.renderBackLink()}
          <HeadingText as='h3' size='md' className={styles.selectedHeader}>
            {this.props.i18n('label.charity-module-chooseAmount')}
          </HeadingText>
        </Row>
        <Row style={{ padding: '10px' }}>
          <Col lg='3'>{this.renderCharityInfo(charity, selectedIndex)}</Col>
          <Col
            lg='5'
            className={`slideInRight hasError ${styles['donation-form-container']}`}
          >
            {this.renderDonationBox(charity)}
          </Col>
          <Col lg='4' className={styles['donation-terms-container']}>
            {this.renderDonationTerms(charity)}
          </Col>
        </Row>
      </div>
    );
  }
}
